exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.rotate {\n    -webkit-transform: rotate(-90deg);\n    transform: rotate(-90deg);\n}\n", ""]);

// exports
